import { render, staticRenderFns } from "./Komoditas.vue?vue&type=template&id=5d612408&scoped=true"
import script from "./Komoditas.vue?vue&type=script&lang=js"
export * from "./Komoditas.vue?vue&type=script&lang=js"
import style0 from "./Komoditas.vue?vue&type=style&index=0&id=5d612408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d612408",
  null
  
)

export default component.exports